<template>

  <div class="c-form-bottom-wrap">
    <div class="c-form-bottom-container">
    <div id="c-formhtml" class="c-formhtml">
      <h2>Formularz kontaktowy</h2>
      <h5>
        Jeżeli chcesz otrzymać ofertę na wybrany samochód, wypełnij i wyślij formularz kontaktowy. Zadzwonimy do Ciebie, aby przygotować indywidualną ofertę.
      </h5>
    </div>
      <div v-html="formHtml">

      </div>
    </div>
  </div>
</template>

<script>
var mylib = require('../form-validate-vanilla');
export default {
  name: 'BottomForm',
  props:[
    'showForm',
    'dealer_id',
    'NumberOffer'
  ],
  data:function(){
    return{
      formUrl: Array(
        {'id': 9, 'url': 'http://audisosnowiec.pl/include/formularz-wyszukiwarka-samochodow-nowych.php'}
      ),
      formHtml:'...',
    }
  },
  methods:{
    getForm: function(id){
        this.axios.get("http://audisosnowiec.pl/include/formularz-wyszukiwarka-samochodow-nowych.php/").then((response) => {
          this.formHtml = response.data;
        })
      }
  },
  watch:{
    dealer_id:function(val){
       this.getForm(val)
    },
    NumberOffer:function(value){
      if (value != 0) {
        document.getElementById('description').value = 'Numer oferty: '+value;
      }
    }
  },
  mounted:function(){
    this.getForm(9)
  }
}
</script>
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.c-formhtml {
  margin: 0 auto;
  max-width: 1177.6px;
  width: 100%;
}
.c-form-bottom{
  &-wrap{
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    padding: 1rem 0 0 0;
    border-top: 1px solid #b3b3b3;
    margin-top: 2rem;
  }
  &-container{

  }
}
.c-form input[type=checkbox] {
    position: relative;
    top: 0px;
    visibility: hidden;
}
</style>
